import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import LeavePopup from '../../page/ProjectPage/components/Carbon/components/LeavePopup';

const RouteLeavingGuard = ({
  children,
  when,
  shouldBlockNavigation,
  navigate = () => {},
  saveChanges = () => {},
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleClose = () => setModalVisible(false);

  const handleBlockedNavigation = (newLocation) => {
    if (!confirmedNavigation && shouldBlockNavigation(newLocation)) {
      setModalVisible(true);
      setNextLocation(newLocation);
      return false;
    }
    return true;
  };

  const handleLeave = () => {
    setConfirmedNavigation(true);
    setModalVisible(false);
  };

  const handleSubmit = () => {
    saveChanges();
    handleClose();
  };

  useEffect(() => {
    window.onbeforeunload = when ? () => true : null;
    return () => {
      window.onbeforeunload = null;
    };
  }, [when]);

  useEffect(() => {
    if (confirmedNavigation && nextLocation) {
      // Navigate to the previous blocked location with navigate function
      navigate(nextLocation.pathname);
    }
  }, [confirmedNavigation, nextLocation]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      {modalVisible && (
        <LeavePopup
          handleClose={handleClose}
          handleLeave={handleLeave}
          handleSubmit={handleSubmit}
        />
      )}
      {children}
    </>
  );
};

export default RouteLeavingGuard;
